module.exports = __webpack_public_path__ + "img/TUR-A-3-I.befc1531.png";